.socialInput {
    display: flex;
    align-items: center;
}

.inputField {
    flex: 1;
}
